<template>
	<div>
		<spinner v-if="movements.loading"/>
		<div v-else class="idi-table movements">
			<div class="idi-header">
				<div class="idi-cell">#</div>
				<div class="idi-cell">{{ $t('labels.general.operation') }}</div>
				<div class="idi-cell">{{ $t('labels.general.value') }}</div>
				<div class="idi-cell">{{ $t('labels.general.current') }}</div>
				<div class="idi-cell">{{ $t('labels.general.message') }}</div>
				<div class="idi-cell">{{ $t('labels.general.date') }}</div>
			</div>
			<div class="idi-row-empty" v-if="!movements.data.length">
				<div class="idi-cell">{{ $t('labels.general.empty') }}</div>
			</div>
			<div class="idi-row" v-for="movement in movements.data" :key="movement.id">
				<div class="idi-cell">
					<span>{{ movement.id }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ movement.operation }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ movement.value }}€</span>
				</div>
				<div class="idi-cell">
					<span>{{ movement.current }}€</span>
				</div>
				<div class="idi-cell">
					<span>{{ movement.message }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ movement.create_time | formatDate(vue) }}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ApiCollection from '@/classes/api/ApiCollection'
export default {
	props: [
		'user_uid'
	],
	data () {
		return {
			vue: this,
			movements: new ApiCollection(),
		}
	},
	methods: {
		getMovements () {
			this.movements.loading = true
			this.$api.subscriptions.operations.getAll(this, this.user_uid)
				.then(response => {
					this.$log.info('subscriptions', 'subscriptions.operations.getAll OK', response)()
					this.movements.data = response.body
				}).catch(error => {
					this.$log.error('subscriptions', 'subscriptions.operations.getAll ERROR', error)()
					this.movements.error = error
				}).finally(() => {
					this.movements.loading = false
				})
		}
	},
	mounted () {
		this.getMovements()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/profile/subscriptions/AccountMovements.vue